module.exports = __webpack_public_path__ + "563f0616.svg";